import { useSelector } from 'react-redux';
import { selectUserProfile } from '../stateManagement/reducers/userProfileReducer';
import { userAllowedThroughFeatureFlag } from '../utils/validation/userAllowedFeatureFlag';

const useFeatureFlag = (environmentVariable: string) => {
  const userRole = useSelector(selectUserProfile).userProfile?.role;
  return userAllowedThroughFeatureFlag(environmentVariable, userRole);
};

export default useFeatureFlag;
